import { Component, ElementRef, EventEmitter, inject, Injector, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Select } from '@upmc-healthplan-npm/ods-wc';
import { DropdownOption } from 'src/app/core/models/global.model';

@Component({
  selector: 'app-single-select-dropdown',
  templateUrl: './single-select-dropdown.component.html',
  styleUrls: ['./single-select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SingleSelectDropdownComponent
    }
  ]
})
export class SingleSelectDropdownComponent implements ControlValueAccessor {
  @Input() options: DropdownOption[];
  @Input() label: string;
  @Input() ariaLabel: string;
  @Input() placeholder: string;
  @Input() disabled: boolean = false;
  @Input() errorMessage: string;
  @Output() value = new EventEmitter<DropdownOption['value']>();

  @ViewChild('select') selectEl: ElementRef<Select>;

  private readonly injector = inject(Injector);

  selectedValue: DropdownOption['value'];
  showErrorMessage: boolean = false;

  onChanged = (_: DropdownOption['value']) => { };
  onTouched = () => { };

  get ngControl(): NgControl {
    return this.injector.get(NgControl);
  }

  get touched(): boolean {
    return this.ngControl?.touched || false;
  }

  get dirty(): boolean {
    return this.ngControl?.dirty || false;
  }

  selectionChanged(value: DropdownOption['value']): void {
    this.markAsTouched();

    if (!this.disabled) {
      this.selectedValue = value;
      this.onChanged(value);
      this.value.emit(value);
    }
  }

  checkValidationClasses(): void {
    const isInvalid = this.selectedValue === null && this.touched;
    const button = this.selectEl.nativeElement.shadowRoot.querySelector('button') as HTMLButtonElement;

    if (!this.disabled && button && isInvalid) {
      button.style.borderColor = 'red';
      button.style.outlineColor = 'red';
      this.showErrorMessage = true;
    } else {
      this.showErrorMessage = false;
      button.style.borderColor = '';
      button.style.outlineColor = '';
    }
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
    }

    this.checkValidationClasses();
  }

  writeValue(obj: DropdownOption['value']): void {
    if (obj === null) {
      obj = '';
      this.ngControl?.control?.markAsUntouched();
    }

    this.selectedValue = obj
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
